import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

/**
 * 
 * hidden  //是否需要隐藏标题栏 true 隐藏 
 * hiddenBack  //是否需要隐藏返回按钮 true 隐藏 
 */

const routes = [
  {
    path: '/',
    name: 'i',
    redirect:"/ticketInfo"
  },
  

  /**
   * 单独的一个页
   */
  // 票证核验二维码
  {
    path: '/billQR',
    name: 'billQR',
    component: () => import('../views/Work/ticket/billDetail.vue'),
    meta:{
      title:'正元智慧追溯一码通',
      // hidden: true,
      hiddenBack:true
    }
  },
  // 交易小票
  {
    path: '/ticketInfo',
    name: 'ticketInfo',
    component: () => import('../views/Work/ticket/ticketInfo.vue'),
    meta:{
      title:'交易小票',
      // hidden: true,
      hiddenBack:true
    }
  },
  // 检测信息
  {
    path: '/testInfo',
    name: 'testInfo',
    component: () => import('../views/Work/ticket/testInfo.vue'),
    meta:{
      title:'检测信息'
    }
  },
  // 商品追溯
  {
    path: '/goodsBack',
    name: 'goodsBack',
    component: () => import('../views/Work/ticket/goodsBack.vue'),
    meta:{
      title:'上游追溯'
    }
  },

]


const router = new VueRouter({
  mode: 'history' ,
  routes
})

router.beforeEach((to, from, next) => {
  var s = to.path.substr(1)
  if(/^-?\d+$/.test(s)){
    next({
      replace:true,
      path:"/ticketInfo",
      query:{
        order_sn:s
      }
    })
  }else{
    next()
  }
})

router.afterEach((to, from) => {
  
})

export default router
